import { CassandraProxyEndpoints, JunoEndpoints, MongoProxyEndpoints, PortalBackendEndpoints } from "Common/Constants";
import * as Logger from "../Common/Logger";
export function validateEndpoint(endpointToValidate, allowedEndpoints) {
    try {
        return validateEndpointInternal(endpointToValidate, allowedEndpoints.map((e) => e));
    }
    catch (reason) {
        Logger.logError(`${endpointToValidate} not allowed`, "validateEndpoint");
        Logger.logError(`${JSON.stringify(reason)}`, "validateEndpoint");
        return false;
    }
}
function validateEndpointInternal(endpointToValidate, allowedEndpoints) {
    if (endpointToValidate === undefined) {
        return false;
    }
    const originToValidate = new URL(endpointToValidate).origin;
    const allowedOrigins = allowedEndpoints.map((allowedEndpoint) => new URL(allowedEndpoint).origin) || [];
    const valid = allowedOrigins.indexOf(originToValidate) >= 0;
    if (!valid) {
        throw new Error(`${endpointToValidate} is not an allowed endpoint. Allowed endpoints are ${allowedEndpoints.toString()}`);
    }
    return valid;
}
export const defaultAllowedArmEndpoints = [
    "https://api-dogfood.resources.windows-int.net/",
    "https://​management.azure.com",
    "https://​management.usgovcloudapi.net",
    "https://management.chinacloudapi.cn",
];
export const defaultAllowedAadEndpoints = [
    "https://login.microsoftonline.com/",
    "https://login.microsoftonline.us/",
    "https://login.partner.microsoftonline.cn/",
];
export const defaultAllowedGraphEndpoints = ["https://graph.microsoft.com"];
export const defaultAllowedBackendEndpoints = [
    "https://localhost:1234",
    PortalBackendEndpoints.Development,
    PortalBackendEndpoints.Mpac,
    PortalBackendEndpoints.Prod,
    PortalBackendEndpoints.Fairfax,
    PortalBackendEndpoints.Mooncake,
];
export const defaultAllowedMongoProxyEndpoints = [
    "https://localhost:1234",
    MongoProxyEndpoints.Development,
    MongoProxyEndpoints.Mpac,
    MongoProxyEndpoints.Prod,
    MongoProxyEndpoints.Fairfax,
    MongoProxyEndpoints.Mooncake,
];
export const defaultAllowedCassandraProxyEndpoints = [
    CassandraProxyEndpoints.Development,
    CassandraProxyEndpoints.Mpac,
    CassandraProxyEndpoints.Prod,
    CassandraProxyEndpoints.Fairfax,
    CassandraProxyEndpoints.Mooncake,
];
export const allowedEmulatorEndpoints = ["https://localhost:8081"];
export const allowedArcadiaEndpoints = ["https://workspaceartifacts.projectarcadia.net"];
export const allowedHostedExplorerEndpoints = [
    "https://cosmos.azure.com",
    ...(process.env.NODE_ENV === "development" ? ["https://localhost:12900"] : []),
];
export const allowedMsalRedirectEndpoints = [
    "https://dataexplorer-preview.portal.cosmos.azure.com/",
];
export const allowedJunoOrigins = [
    JunoEndpoints.Test,
    JunoEndpoints.Test2,
    JunoEndpoints.Test3,
    JunoEndpoints.Prod,
    JunoEndpoints.Stage,
    "https://localhost",
];
export const allowedNotebookServerUrls = [];
